<template>
  <v-container class="pa-0">
    <!-- Premium Header -->
    <v-sheet color="primary" class="pa-6 d-flex align-center">
      <v-avatar size="40" color="white opacity-20" class="mr-4">
        <v-icon color="white" small>fas fa-user-tag</v-icon>
      </v-avatar>
      <div>
        <div class="text-h5 white--text font-weight-black">Asignación de Equipos</div>
        <div class="caption white--text opacity-70">Delegue procesos a estaciones de trabajo específicas</div>
      </div>
      <v-spacer></v-spacer>
      <v-btn icon color="white" @click="$emit('close')"><v-icon small>fas fa-times</v-icon></v-btn>
    </v-sheet>

    <ValidationObserver v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(save)" class="pa-6">
        <!-- Selected Processes List -->
        <v-card outlined class="modern-card overflow-hidden mb-6">
          <v-simple-table class="modern-table">
            <thead>
              <tr>
                <th class="grey lighten-5" width="80">OT</th>
                <th class="grey lighten-5">Cliente y Producto</th>
                <th class="grey lighten-5">Proceso</th>
                <th class="grey lighten-5 text-center" width="160">Carga Actual</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="process in processes" :key="process.id">
                <td class="text-center font-weight-black grey--text text--darken-2">#{{ process.work_order }}</td>
                <td class="py-3">
                  <div class="caption font-weight-bold secondary--text mb-n1">{{ process.customer_name }}</div>
                  <div class="body-2 font-weight-medium grey--text text--darken-4 text-truncate" style="max-width: 250px;">
                    <span v-if="process.product_sku" class="primary--text font-weight-black opacity-70">[{{ process.product_sku }}]</span>
                    {{ process.product_name }}
                  </div>
                </td>
                <td>
                  <v-chip x-small label dark color="primary" class="font-weight-black shadow-xs">{{ process.name.toUpperCase() }}</v-chip>
                </td>
                <td>
                  <div class="d-flex justify-space-between caption font-weight-bold mb-1">
                    <span v-if="machine.production_unit_m2">{{ process.total_mts2 | number('0.0') }} / {{ process.product_mts2 | number('0.0') }} m²</span>
                    <span v-else>{{ process.total_qty | number('0.0') }} / {{ process.product_qty | number('0.0') }} un</span>
                  </div>
                  <v-progress-linear
                    color="primary"
                    height="4"
                    rounded
                    :value="machine.production_unit_m2 ? (process.total_mts2 / process.product_mts2 * 100) : (process.total_qty / process.product_qty * 100)"
                  />
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>

        <!-- Assignment Selection -->
        <v-card outlined class="modern-card pa-6 bg-grey-light">
          <ValidationProvider name="Equipo" rules="required" v-slot="{ errors }">
            <v-select
              label="Seleccionar Equipo de Destino"
              v-model="equipment"
              :items="equipmentList"
              item-text="name"
              item-value="id"
              outlined dense hide-details="auto"
              class="modern-select mb-2 bg-white"
              :error-messages="errors"
              prepend-inner-icon="fas fa-microchip"
              placeholder="Eliga el equipo o estación responsable"
            />
          </ValidationProvider>
          <div class="caption grey--text font-italic mt-2">
            La asignación se aplicará a los {{ processes.length }} procesos seleccionados simultáneamente.
          </div>
        </v-card>

        <!-- Actions -->
        <div class="d-flex justify-end pt-8 gap-3">
          <v-btn text color="grey darken-1" class="font-weight-bold px-8" @click="$emit('close')">Cancelar</v-btn>
          <v-btn type="submit" color="primary" depressed class="font-weight-bold px-10 shadow-sm" :loading="loading">
            <v-icon small class="mr-2">fas fa-user-check</v-icon> Confirmar Asignación
          </v-btn>
        </div>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { asignEquipment } from '@/api/production'
import notifications from '@/utils/notifications'

export default {
  name: 'AsignEquipment',
  props: ['processes', 'machine'],
  data() {
    return {
      equipment: '',
      loading: false,
    }
  },
  methods: {
    async save() {
      this.loading = true
      try {
        const res = await asignEquipment({
          processes: this.processes,
          equipment: this.equipment,
        })
        notifications.showSuccess('Equipo asignado correctamente')
        this.$emit('refresh')
        this.$emit('close')
      } catch (e) {
        notifications.showError('Error al asignar equipo: ' + e)
      } finally {
        this.loading = false
      }
    },
  },
  computed: {
    equipmentList() {
      return this.machine.equipments ? this.machine.equipments.filter(e => e.enabled) : []
    }
  }
}
</script>

<style scoped>
.modern-card { border: 1px solid rgba(0,0,0,0.08) !important; border-radius: 12px !important; }
.bg-grey-light { background-color: #f8f9fa; }
.opacity-20 { background-color: rgba(255,255,255,0.2) !important; }
.opacity-70 { opacity: 0.7; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important; }
.shadow-xs { box-shadow: 0 1px 2px rgba(0,0,0,0.03) !important; }
.gap-3 { gap: 12px; }
.modern-table >>> td { padding: 12px 16px !important; border-bottom: 1px solid rgba(0,0,0,0.04) !important; }
</style>
